import { Form, FormRule, FormItemProps } from "antd";
import { ReactNode } from "react";

interface IProps extends FormItemProps {
  name: string;
  label?: string;
  component: ReactNode;
  hasFeedback?: boolean;
  rules?: FormRule[];
  dependencies?: any;
  validateTrigger?: string | string[];
}
export default function FormFieldUI(props: IProps) {
  //! state
  const { name, label, component, hasFeedback, rules, dependencies, validateTrigger, ...res } = props;
  //! function
  //! render
  return (
    <Form.Item
      name={name}
      hasFeedback={hasFeedback}
      label={label}
      rules={rules}
      dependencies={dependencies}
      validateTrigger={validateTrigger ?? "onBlur"}
      {...res}
    >
      {component}
    </Form.Item>
  );
}
